<template>
  <div class="w-full overflow-hidden box-border bg-[#181818]">
    <div class="flex items-center justify-between h-[55px] md:h-[84px] px-[10px] md:px-[20px]">
      <!-- <img v-if="logo" class="w-[148px] md-w-[282px]" :src="logo" alt="" @click="handelRouer" /> -->
      <div class="site-brand w-[148px] md:w-[282px]">
        <span class="site-brand__name">{{ web_name }}</span>
        <span class="site-brand__slash">/</span>
        <span class="site-brand__domain">{{ logo }}</span>
      </div>
      <!-- <div class="text-[#fff] text-[20px] font-600 p-[10px]" @click="handelRouer">
        {{ web_name }}
      </div> -->
      <div
        class="w-[202px] md:w-[320px] flex items-center justify-center gap-[10px] md:gap-[20px] h-[40px]"
      >
        <div>
          <van-field
            class="h-[30px] py-[6px] px-[10px] text-[#fff]"
            style="background-color: #282828; border-radius: 8px; color: #fff"
            v-model="vod_name"
            @click-right-icon="onSearch"
            right-icon="search"
            placeholder="请输入关键词..."
          />
        </div>
        <div class="w-[27px] h-[31px]" @click="handelcd">
          <svg
            t="1742791083516"
            class="icon w-[27px] h-[31px]"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="6355"
            id="mx_n_1742791083518"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="512"
            height="512"
          >
            <path
              d="M307.8 951.6H166.6c-61.1 0-110.8-49.7-110.8-110.8V119c0-61 49.8-110.7 110.8-110.7H722C783.2 8.3 832.9 58 832.9 119v220.4c0 16-13 29-29 29s-29-13-29-29V119c0-29.1-23.7-52.7-52.7-52.7H166.6c-29.1 0-52.7 23.7-52.7 52.7v721.7c0 29.1 23.7 52.7 52.7 52.7h141.1c16 0 29 13 29 29s-12.9 29.2-28.9 29.2z"
              fill="#fbc600"
              p-id="6356"
            ></path>
            <path
              d="M598.2 244.5H220.7c-16 0-29-13-29-29s13-29 29-29h377.4c16 0 29 13 29 29s-12.9 29-28.9 29zM437.1 405.4H220.7c-16 0-29-13-29-29s13-29 29-29h216.4c16 0 29 13 29 29s-13 29-29 29zM675.9 1015c-77.9 0-151.2-30.3-206.2-85.4s-85.4-128.3-85.4-206.2 30.3-151.2 85.4-206.2c55.1-55.1 128.3-85.4 206.2-85.4S827 462 882.1 517.1c55.1 55.1 85.4 128.3 85.4 206.2s-30.3 151.2-85.4 206.2-128.3 85.5-206.2 85.5z m0-542.4c-138.3 0-250.8 112.5-250.8 250.8s112.5 250.8 250.8 250.8 250.8-112.5 250.8-250.8-112.5-250.8-250.8-250.8z"
              fill="#fbc600"
              p-id="6357"
            ></path>
            <path
              d="M675.9 1005.2c-57.4 0-88.3-145.2-88.3-281.9s31-281.9 88.3-281.9c57.4 0 88.3 145.2 88.3 281.9s-30.9 281.9-88.3 281.9z m0-545.3c-15.9 0-34 28-47.1 73.2-14.7 50.7-22.8 118.2-22.8 190.2s8.1 139.5 22.8 190.2c13.1 45.2 31.1 73.2 47.1 73.2 15.9 0 34-28 47.1-73.2 14.7-50.7 22.8-118.2 22.8-190.2 0-72-8.1-139.5-22.8-190.2-13.1-45.2-31.2-73.2-47.1-73.2z"
              fill="#fbc600"
              p-id="6358"
            ></path>
            <path
              d="M675.9 811.7c-136.7 0-281.9-31-281.9-88.4 0-57.4 145.2-88.3 281.9-88.3s281.9 31 281.9 88.3c0 57.4-145.3 88.4-281.9 88.4z m0-158.2c-72 0-139.5 8.1-190.2 22.8-45.2 13.1-73.2 31.1-73.2 47.1 0 15.9 28 34 73.2 47.1 50.7 14.7 118.2 22.8 190.2 22.8s139.5-8.1 190.2-22.8c45.2-13.1 73.2-31.1 73.2-47.1 0-15.9-28-34-73.2-47.1-50.7-14.7-118.2-22.8-190.2-22.8z"
              fill="#fbc600"
              p-id="6359"
            ></path>
          </svg>
          <!-- <svg
            t="1742726012481"
            class="icon w-[27px] h-[31px]"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="6704"
            data-spm-anchor-id="a313x.search_index.0.i0.59773a81N477PZ"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="512"
            height="512"
          >
            <path
              d="M737.7 171.8v299.6C689 434.6 643.9 400.6 598 365.9c-45.1 34.6-89.7 68.7-137.9 105.6V165.6c-29.2 0-55.5-0.3-81.8 0.1-33.7 0.5-67.7-1-101 2.8-47.3 5.4-81.5 45.3-81.6 92.6-0.4 162.2-0.4 324.3 0 486.5 0.1 54.4 42.1 93.7 100.7 95.9 17.2 0.6 34.4 0.2 51.6 0.1 15.7 0 25.8 7 26 23.3 0.2 16.2-10.1 24.2-25.4 24.2-27.1-0.2-54.5 1-81.1-2.9-67.8-10.2-118.8-66.7-119.4-135.7-1.4-165.5-1.6-331 0.1-496.4 0.8-77.4 65.8-137.7 143.4-138 142.3-0.5 284.6-0.6 426.9-0.5 70.5 0 137.5 60.9 139.8 131.6 2.7 84 1.1 168.1 1.1 252.2 0 15.6-8.3 25.3-24.5 24.9-17.6-0.5-23.6-12.6-23.6-28.3-0.2-60.9-0.1-121.8-0.1-182.7 0-19.2 0.5-38.4-0.1-57.6-1.3-42.1-33.6-80.5-73.4-85.9zM597.8 305.1c30.3 22.8 59 44.4 89.8 67.6V168.9H509.3v203.7c30.9-23.5 59.1-45 88.5-67.5z"
              fill="#1195FE"
              p-id="6705"
            ></path>
            <path
              d="M651.9 764.7H485.4c-4.6 0-9.3 0.2-13.9-0.1-15.1-1.1-25.6-8.1-25.5-24.3 0.1-16.2 10.4-23.5 25.8-23.7 27.7-0.3 55.5-0.1 83.2-0.1h263.6c4.6 0 9.3 0.1 13.9 0 15.7-0.1 25.9 7.2 26.3 23.1 0.5 17.1-10.2 25-26.6 25.1-43.6 0.2-87.2 0.1-130.8 0.1-16.5-0.1-33-0.1-49.5-0.1zM651.9 891.6H485.4c-4.6 0-9.3 0.2-13.9-0.1-15.1-1.1-25.6-8.1-25.5-24.3 0.1-16.2 10.4-23.5 25.8-23.7 27.7-0.3 55.5-0.1 83.2-0.1h263.6c4.6 0 9.3 0.1 13.9 0 15.7-0.1 25.9 7.2 26.3 23.1 0.5 17.1-10.2 25-26.6 25.1-43.6 0.2-87.2 0.1-130.8 0.1-16.5-0.1-33-0.1-49.5-0.1zM652.3 638.3c-58.2 0-116.3 0.1-174.5 0-21.5 0-32.1-8-32.1-23.5 0-15.9 10.5-24.7 31.5-24.7 117-0.2 233.9-0.2 350.9 0 20.6 0 31.9 9.3 30.8 25.1-1.3 18.6-13.4 23.4-30.2 23.3-58.7-0.5-117.5-0.2-176.4-0.2z"
              fill="#1195FE"
              p-id="6706"
            ></path>
          </svg> -->
        </div>
        <!-- <van-icon color="#f2990d" size="35" name="wap-nav" @click="handelcd" /> -->
      </div>
    </div>
    <!-- 导航 -->
    <div class="flex justify-between items-center h-[40px] overflow-hidden box-border bg-[#282828]">
      <div class="text-[#fff] text-[18px] flex items-center">
        <!-- <van-icon name="arrow-double-left" @click="scrollLeft" /> -->
      </div>
      <div
        class="flex justify-between h-full items-center flex-nowrap gap-[10px] overflow-x-scroll scroll-container"
        id="containers"
      >
        <div
          v-for="(item, index) in typeClass"
          :key="index"
          :id="'btn' + index"
          class="text-[14px] flex items-center text-[#fff] px-[15px] justify-center h-full no-warp user-select-none"
          :class="[navIndex == index ? 'bg-[#ff4d03]' : '']"
          @click="onClickNav(item, index, 'type')"
        >
          {{ item.type_name }}
        </div>
      </div>
      <div class="text-[#fff] text-[rem] flex items-center ml-[0.1rem]"></div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue'
import { useRouter } from 'vue-router'
import { pcScrollX } from '@/utils/common'
const router = useRouter()
const props = defineProps({
  logo: {
    type: String,
    default: ''
  },
  typeClass: {
    type: Array,
    default: () => []
  },
  web_name: {
    type: String,
    default: ''
  },
  isIndex: {
    type: Boolean,
    default: false
  },
  isHome: {
    type: Boolean,
    default: false
  }
})
const vod_name = ref('')

onMounted(() => {
  sessionStorage.getItem('vod_name') && (vod_name.value = sessionStorage.getItem('vod_name'))
})

// const page = ref(1)
const loading = ref(false)
const navIndex = ref(0)
const onClickNav = (item, index, type, num = 0) => {
  if (index == 0) {
    sessionStorage.removeItem('isIndex')
    localStorage.removeItem('page')
    if (props.isHome) {
      location.reload()
    } else {
      router.push('/')
    }
    return
  }
  sessionStorage.setItem('isIndex', index)
  if (type) {
    localStorage.removeItem('page')
  }
  if (props.isIndex && type) {
    router.back()
  } else {
    emits('onNav', { item, num })
  }
  // page.value = 1
  navIndex.value = index
  loading.value = true
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
  nextTick(() => {
    const dom = document.getElementById('btn' + navIndex.value)
    const container = document.getElementById('containers') // 指定容器
    container.scrollTo({
      left: dom.offsetLeft - container.offsetWidth / 2 + dom.offsetWidth / 2, // 让按钮在容器中居中
      behavior: 'smooth' // 平滑滚动
    })
  })

  // tx(item.id)
  // if (item.id == 0) {
  //   // isIndex.value = 1
  //   router.push({
  //     path: 'home'
  //   })
  // } else {
  //   router.push({
  //     path: 'listView',
  //     query: {
  //       id: item.id
  //     }
  //   })
  // }
}
const emits = defineEmits(['handelcd', 'onNav', 'onSearch'])
const handelcd = () => {
  emits('handelcd')
}
const onSearch = () => {
  if (props.isIndex) {
    sessionStorage.setItem('vod_name', vod_name.value)
    // router.back()
    router.push('/')
  } else {
    emits('onSearch', vod_name.value)
  }
}
// const handelShow = () => {
//   console.log('handelShow1')

//   emits('handelShow')
// }
const homeClassNav = (page) => {
  const index = sessionStorage.getItem('isIndex')
  // console.log(index, props.typeClass, 'index')
  if (index) {
    onClickNav(props.typeClass[+index], +index, '', page)
  }
}
const scrollDistance = 200 // 每次滚动距离
function scrollLeft() {
  const scrollBox = document.getElementById('containers')
  scrollBox.scrollBy({ left: -scrollDistance, behavior: 'smooth' })
}

function scrollRight() {
  const scrollBox = document.getElementById('containers')
  scrollBox.scrollBy({ left: scrollDistance, behavior: 'smooth' })
}

const handelRouer = () => {
  sessionStorage.removeItem('isIndex')
  localStorage.removeItem('page')
  if (props.isHome) {
    location.reload()
  } else {
    router.push('/')
  }
}
defineExpose({ homeClassNav })
</script>

<style scoped>
:deep(.van-cell) {
  line-height: normal;
}
/* 隐藏 Chrome、Safari 和 Edge 滚动条 */
.scroll-container::-webkit-scrollbar {
  display: none;
}
.scroll-container {
  user-select: none;
}
:deep(.van-field__control) {
  color: #fff;
}
.site-brand {
  position: relative;
  height: 42px;
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  overflow: hidden;
}

.site-brand::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 5px;
  width: 72%;
  height: 2px;
  border-radius: 999px;
  background: linear-gradient(90deg, #00eaff, #7c3cff, transparent);
  opacity: 0.75;
  filter: blur(0.3px);
}

.site-brand__name {
  position: relative;
  z-index: 1;
  flex-shrink: 0;
  font-size: 22px;
  font-weight: 900;
  line-height: 1;
  letter-spacing: 0.5px;
  color: #ffffff;
  background: linear-gradient(135deg, #ffffff 0%, #6ffcff 38%, #9f7cff 72%, #ffffff 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow:
    0 0 8px rgba(0, 234, 255, 0.45),
    0 0 18px rgba(124, 60, 255, 0.35);
}

.site-brand__slash {
  flex-shrink: 0;
  color: #6ffcff;
  font-size: 18px;
  font-weight: 700;
  transform: skewX(-12deg);
  text-shadow: 0 0 8px rgba(0, 234, 255, 0.8);
}

.site-brand__domain {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.72);
  transform: translateY(2px);
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.15);
}
</style>
